import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-314">
      <div className="max-w-5xl mx-auto" data-id="element-315">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-316">
          Lo que <span className="text-[#FFD700]" data-id="element-317">recibes</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-318">
          {/* Primaria */}
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-319">
            <h3 className="text-[#FFD700] text-xl font-black mb-2" data-id="element-320">
              📘 EDUCACIÓN PRIMARIA / BÁSICA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-2" data-id="element-321">
              Para docentes de Música de 1° a 6° Grado / Año
            </p>
            <p className="text-gray-500 text-xs italic mb-5" data-id="element-322">
              Tanto si tu sistema educativo lo llama Primaria, Básica, Elemental
              o Educación Fundamental, estos seis tomos cubren los seis años del
              primer ciclo escolar de tu país.
            </p>
            <div className="space-y-4" data-id="element-323">
              <div className="flex items-start gap-3 text-white" data-id="element-324">
                <span className="text-xl mt-1" data-id="element-325">📘</span>
                <div data-id="element-326">
                  <span className="font-bold" data-id="element-327">Tomo 1 — 1° Grado / Año:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-328">
                    {' '}
                    Exploradores Sonoros
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-329">
                    El cuerpo como instrumento, el sonido, el silencio y el
                    pulso
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-330">
                <span className="text-xl mt-1" data-id="element-331">📗</span>
                <div data-id="element-332">
                  <span className="font-bold" data-id="element-333">Tomo 2 — 2° Grado / Año:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-334">
                    {' '}
                    Ritmo y Movimiento
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-335">
                    La melodía, la voz, el canto y la creación melódica básica
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-336">
                <span className="text-xl mt-1" data-id="element-337">📙</span>
                <div data-id="element-338">
                  <span className="font-bold" data-id="element-339">Tomo 3 — 3° Grado / Año:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-340">
                    {' '}
                    Historias con Sonidos
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-341">
                    Grafías no convencionales y lectoescritura musical
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-342">
                <span className="text-xl mt-1" data-id="element-343">📕</span>
                <div data-id="element-344">
                  <span className="font-bold" data-id="element-345">Tomo 4 — 4° Grado / Año:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-346">
                    {' '}
                    Nuestra Identidad Sonora
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-347">
                    Instrumentos del mundo, cotidiáfonos y orquesta de aula
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-348">
                <span className="text-xl mt-1" data-id="element-349">📓</span>
                <div data-id="element-350">
                  <span className="font-bold" data-id="element-351">Tomo 5 — 5° Grado / Año:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-352">
                    {' '}
                    Arquitectos Musicales
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-353">
                    Apreciación musical y géneros del mundo hispanohablante
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-354">
                <span className="text-xl mt-1" data-id="element-355">📔</span>
                <div data-id="element-356">
                  <span className="font-bold" data-id="element-357">Tomo 6 — 6° Grado / Año:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-358">
                    {' '}
                    Música y Tecnología
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-359">
                    Creación colectiva y proyecto musical final de ciclo
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Secundaria */}
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-360">
            <h3 className="text-[#FFD700] text-xl font-black mb-2" data-id="element-361">
              📗 EDUCACIÓN SECUNDARIA / MEDIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-2" data-id="element-362">
              Para docentes de Música de 1° a 6° Año / Grado
            </p>
            <p className="text-gray-500 text-xs italic mb-5" data-id="element-363">
              Tanto si tu sistema lo llama Secundaria, Media, Bachillerato,
              Preparatoria o Liceo, estos seis tomos cubren los seis años del
              segundo ciclo escolar de tu país.
            </p>
            <div className="space-y-4" data-id="element-364">
              <div className="flex items-start gap-3 text-white" data-id="element-365">
                <span className="text-xl mt-1" data-id="element-366">📘</span>
                <div data-id="element-367">
                  <span className="font-bold" data-id="element-368">Tomo 1 — 1° Año / Grado:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-369">
                    {' '}
                    El Fenómeno Sonoro
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-370">
                    Teoría musical aplicada, escalas y lectura musical fluida
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-371">
                <span className="text-xl mt-1" data-id="element-372">📗</span>
                <div data-id="element-373">
                  <span className="font-bold" data-id="element-374">Tomo 2 — 2° Año / Grado:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-375">
                    {' '}
                    El Lenguaje de la Melodía
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-376">
                    Historia de la música: del Barroco a la Era Digital
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-377">
                <span className="text-xl mt-1" data-id="element-378">📙</span>
                <div data-id="element-379">
                  <span className="font-bold" data-id="element-380">Tomo 3 — 3° Año / Grado:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-381">
                    {' '}
                    Música, Sociedad y Forma
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-382">
                    Armonía moderna y composición de canciones propias
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-383">
                <span className="text-xl mt-1" data-id="element-384">📕</span>
                <div data-id="element-385">
                  <span className="font-bold" data-id="element-386">Tomo 4 — 4° Año / Grado:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-387">
                    {' '}
                    Creación y Producción
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-388">
                    Música, tecnología y producción digital
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-389">
                <span className="text-xl mt-1" data-id="element-390">📓</span>
                <div data-id="element-391">
                  <span className="font-bold" data-id="element-392">Tomo 5 — 5° Año / Grado:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-393">
                    {' '}
                    Música, Imagen y Narrativa
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-394">
                    Géneros urbanos y análisis crítico
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-395">
                <span className="text-xl mt-1" data-id="element-396">📔</span>
                <div data-id="element-397">
                  <span className="font-bold" data-id="element-398">Tomo 6 — 6° Año / Grado:</span>
                  <span className="text-[#FFD700] font-semibold" data-id="element-399">
                    {' '}
                    Del Aula al Escenario Global
                  </span>
                  <p className="text-gray-400 text-xs mt-1" data-id="element-400">
                    Práctica de conjunto y gestión de proyectos musicales
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#FFD700]/5 border border-[#FFD700]/30 rounded-2xl p-8 text-center mb-8" data-id="element-401">
          <h3 className="text-[#FFD700] text-xl font-black mb-6" data-id="element-402">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-403">
            <div className="flex items-start gap-2 text-left" data-id="element-404">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-405">✅</span>
              <span className="text-white text-sm" data-id="element-406">
                Planificación anual lista para tu carpeta docente
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-407">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-408">✅</span>
              <span className="text-white text-sm" data-id="element-409">
                Guion de clase completo con inicio, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-410">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-411">✅</span>
              <span className="text-white text-sm" data-id="element-412">
                Actividades concretas que funcionan sin instrumentos costosos
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-413">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-414">✅</span>
              <span className="text-white text-sm" data-id="element-415">
                Rúbricas y evidencias de evaluación listas para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-416">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-417">✅</span>
              <span className="text-white text-sm" data-id="element-418">
                Proyectos integradores por unidad didáctica
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-419">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-420">✅</span>
              <span className="text-white text-sm" data-id="element-421">
                Lenguaje neutro que funciona en cualquier país hispanohablante
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-422">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-423">✅</span>
              <span className="text-white text-sm" data-id="element-424">
                Alineado a los lineamientos pedagógicos internacionales UNESCO
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-425">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-426">✅</span>
              <span className="text-white text-sm" data-id="element-427">
                Canciones para actos escolares incluidas en cada tomo
              </span>
            </div>
          </div>
        </div>

        {/* Why it works internationally */}
        <div className="bg-black border border-white/10 rounded-2xl p-8 text-center" data-id="element-428">
          <h3 className="text-white text-lg font-bold mb-4" data-id="element-429">
            ¿Por qué funciona en cualquier país hispanohablante?
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed italic max-w-4xl mx-auto" data-id="element-430">
            Escrito en español neutro, sin regionalismos y con terminología
            inclusiva para todos los sistemas educativos. El contenido musical
            abarca géneros de todo el mundo hispanohablante: flamenco, cumbia,
            huayno, son cubano, corrido, tango y mucho más. Este material fue
            creado para ti, dondequiera que estés.
          </p>
        </div>
      </div>
    </section>;
}